/* Component to fetch the Advanced Schedule data
 * Contain the Advanced Schedule to which it passses the data
 * Note: The Advanced Schedule is the first half of the next day's schedule*/
import React, { useEffect, useState } from "react";

import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import AdvancedSchedule2 from "./AdvancedSchedule2";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";

const AdvancedSchedPage2 = (props) => {
  const host = useHostName();
  const { setShow, advancedDay } = props;
  // eslint-disable-next-line
  const [hasLoaded, setHasLoaded] = useState(false);
  const [dayInfo, setDayInfo] = useState({ results: [] });
  const [advancedSchedule, setAdvancedSchedule] = useState({ results: [] });
  // eslint-disable-next-line
  const [error, setErrors] = useState({});

  const advancedSchedule5 = (Array.isArray(advancedSchedule?.results)
    ? [...advancedSchedule.results]
    : []
  )
    .sort(
      (a, b) =>
        (a?.day_order_number ?? Number.MAX_SAFE_INTEGER) -
        (b?.day_order_number ?? Number.MAX_SAFE_INTEGER)
    )
    .slice(0, 5);

  useEffect(() => {
    /* Fetch day data and day schedule scenes data for the advancedDay */
    const fetchAdvancedSchedule = async () => {
      if (!advancedDay) return;
      setHasLoaded(false);
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [{ data: dayGet }, { data: scenes }] = await Promise.all([
            axiosReq.get(`/days/${advancedDay}`),
            axiosReq.get(`/schedule/scenes/?day_id=${advancedDay}&is_second_unit=true`),
          ]);
          setDayInfo({ results: [dayGet] });
          setAdvancedSchedule(scenes);
          setHasLoaded(true);
        } else {
          const [{ data: dayGet }, { data: scenes }] = await Promise.all([
            axiosInstance.get(
              `${localStorage.getItem("projectSlug")}/days/${advancedDay}/?is_second_unit=true`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            axiosInstance.get(
              `${localStorage.getItem("projectSlug")}/schedule/scenes/?day_id=${advancedDay}&is_second_unit=true`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
          ]);
          setDayInfo({ results: [dayGet] });
          setAdvancedSchedule(scenes);
          setHasLoaded(true);
        }
      } catch (err) {
        console.log(err);
        if (err.response?.status !== 401) {
          setErrors(err.response?.data);
          setHasLoaded(true);
        }
      }
    };
    fetchAdvancedSchedule();
    // eslint-disable-next-line
  }, [advancedDay, host]);

  return (
    <div>
      {hasLoaded ? (
        <>
        <AdvancedSchedule2
        setShow={setShow}
        dayInfo={dayInfo?.results[0]}
        scenes={advancedSchedule5}
      />
        </>
      ) :
      ("")}
    </div>
  );
};

export default AdvancedSchedPage2;
